export interface ICSOptions {
	id: string;
	title: string;
	description?: string;
	location?: string;
	startDate: Date;
	endDate: Date;
}

function formatDateToICS(date: Date): string {
	// Converts date to UTC format required by ICS (e.g., 20251030T153000Z)
	return date.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
}

export function downloadICS({ id, title, description, location, startDate, endDate }: ICSOptions): void {
	const formattedStart = formatDateToICS(startDate);
	const formattedEnd = formatDateToICS(endDate);

	const icsContent = `BEGIN:VCALENDAR
VERSION:2.0
CALSCALE:GREGORIAN
BEGIN:VEVENT
SUMMARY:${title}
DESCRIPTION:${description || ""}
LOCATION:${location || ""}
DTSTART:${formattedStart}
DTEND:${formattedEnd}
BEGIN:VALARM
TRIGGER:-PT180M
ACTION:DISPLAY
DESCRIPTION:Reminder
END:VALARM
END:VEVENT
END:VCALENDAR`;

	const blob = new Blob([icsContent], { type: "text/calendar;charset=utf-8" });
	const url = URL.createObjectURL(blob);

	const link = document.createElement("a");
	link.href = url;
	link.download = `${title.replace(/\s+/g, "_") + "_" + id}.ics`;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}
